import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  additionalHosts: hasMany('employee', { inverse: null }),
  agreeableNdas: hasMany('agreeable-nda'),
  attendee: belongsTo('attendee'),
  childInviteLocations: hasMany('location', { inverse: null }),
  creator: belongsTo('user'),
  employee: belongsTo('employee', { inverse: null }),
  entry: belongsTo('entry'),
  flow: belongsTo('flow'),
  groupInvite: belongsTo('group-invite'),
  location: belongsTo('location'),
  multiTenancyVisitorNotificationLogs: hasMany('notification-log'),
  parentInviteContext: belongsTo('parent-invite-context', { inverse: null }),
  platformJobs: hasMany('platform-job'),
  recurringInvite: belongsTo('recurring-invite'),
  reservation: belongsTo('reservation'),
  signedAgreementsJob: belongsTo('signed-agreements-job'),
  suites: hasMany('zone'),
  tenant: belongsTo('tenant'),
  visitorDocuments: hasMany('visitor-document'),
});
